<nav class="navbar navbar-raised" aria-label="menu">
  <span class="navbar-logo flex-grow-0" [class.justify-content-start]="!vm?.isLoggedIn" [class.flex-grow-1]="!vm?.isLoggedIn">
    <osn-cxb-tenant-logo></osn-cxb-tenant-logo>
  </span>
  <div class="navbar-items d-flex" *ngIf="vm?.isLoggedIn">
    <ng-container *ngFor="let item of menuItems$ | async">
      <a *ngIf="item.url !== '/settings'" class="navbar-item" [routerLink]="item.url" routerLinkActive="navbar-item-active">
        {{ item.title }}
      </a>
      <osn-cxb-settings-menu *ngIf="item.url === '/settings'"></osn-cxb-settings-menu>
    </ng-container>
  </div>
  <osn-cxb-profile-menu *ngIf="!vm?.isLoading"></osn-cxb-profile-menu>

  <svg-icon
    *ngIf="globalFileUploadService.globalFileUploadEnabled"
    class="mass-file-upload-icon"
    size="md"
    [matTooltip]="
      'This button lets you upload one image to all image inputs to save time when testing and developing. It’s only a testing tool, not going to appear on preprod and prod.'
    "
    key="episodes"
    (click)="globalFileUploadService.uploadFileIntoAvailableTargets()"
  ></svg-icon>

  <!--
  <div *ngIf="vm?.username" class="navbar-account">
    <span class="navbar-account-name">{{ vm.username }}</span>
  </div>
  <button *ngIf="!vm?.isLoggedIn; else logout" (click)="onLoginClicked()">Login</button>
  <ng-template #logout>
    <button (click)="onLogoutClicked()">Logout</button>
  </ng-template>
  <button
    *ngIf="globalFileUploadService.globalFileUploadEnabled"
    (click)="globalFileUploadService.uploadFileIntoAvailableTargets()"
    class="ml-3"
  >
    Mass image upload
  </button>
  -->
  <p class="version" *ngIf="version">{{ version }}, backend: {{ apiVersion$ | async }}</p>
</nav>
